<template>
  <div class="this-page">
    <template>
      <toolBar useSearch @clear="clearSearch" @search="searchOrder"/>
    </template>
    <template>
      <el-table :data="list" :height="tableHeight" border size="small" stripe style="width: 100%">
        <el-table-column fixed label="快递单号" prop="express_no" width="150">
        </el-table-column>
        <el-table-column label="会员号" prop="uid" width="80">
        </el-table-column>
        <el-table-column label="入库状态" prop="avatar" width="70">
          <template slot-scope="scope">
            <el-tag :type="scope.row.check_stock == 1?'success':'danger'" size="mini">
              {{ scope.row.check_stock == 1 ? '已入库' : '未入库' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="入库时间" prop="check_time" width="150">
        </el-table-column>
        <el-table-column label="仓位" prop="stockName" width="70">
        </el-table-column>
        <el-table-column label="货架码" prop="shelves_id" width="70">
        </el-table-column>
        <el-table-column label="总重" min-width="70" prop="total_weight">
        </el-table-column>
        <el-table-column label="称重" min-width="70" prop="weight">
        </el-table-column>
        <el-table-column label="抛重" min-width="70" prop="bulky">
        </el-table-column>
        <el-table-column label="长度" min-width="70" prop="length">
        </el-table-column>
        <el-table-column label="宽度" min-width="70" prop="width">
        </el-table-column>
        <el-table-column label="高度" min-width="70" prop="height">
        </el-table-column>
        <el-table-column label="体积" min-width="70" prop="volume">
        </el-table-column>
        <el-table-column label="货物简述" min-width="200" prop="package_mark">
        </el-table-column>
        <el-table-column label="备注" min-width="200" prop="note">
        </el-table-column>
        <el-table-column label="物品数量" prop="item_number" width="80">
        </el-table-column>
        <el-table-column label="报关总价" prop="total_price" width="80">
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" width="150">
        </el-table-column>
        <el-table-column label="关联订单" prop="orderNo" width="150">
        </el-table-column>
        <el-table-column label="关联团编号" prop="group_id" width="150">
        </el-table-column>
        <el-table-column label="入库照片" property="check_pic" width="100px">
          <template slot-scope="scope">
            <el-image
                :preview-src-list="scope.row.check_pic ? [scope.row.check_pic]:[]"
                :src="scope.row.check_pic || '无'"
                fit="cover"
                style="width: 60px; height: 60px">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="入库照片2" property="check_pic2" width="100px">
          <template slot-scope="scope">
            <el-image
                :preview-src-list="scope.row.check_pic2 ? [scope.row.check_pic2]:[]"
                :src="scope.row.check_pic2 || '无'"
                fit="cover"
                style="width: 60px; height: 60px">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="是否转订单" prop="created_at" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.to_order == 1?'success':'danger'" size="mini">
              {{ scope.row.to_order == 1 ? '已转' : '未转' }}
            </el-tag>
            <el-button v-if="scope.row.to_order == 0" circle icon="el-icon-close" size="mini" style="margin-left:20px"
                       type="danger" @click="deletePackage(scope.row.id)"></el-button>
          </template>
        </el-table-column>

      </el-table>
      <template>
        <el-pagination :current-page="page" :page-count="pageCount" background layout="prev, pager, next"
                       style="margin-top:20px"
                       @current-change="pageChange">
        </el-pagination>
      </template>
    </template>

  </div>
</template>
<script>
import toolBar from '../../components/tool-bar/index.vue'

export default {
  components: {
    toolBar
  },
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 165 + 'px',
      load: {
        list: false
      },
      page: 1,
      searchValue: '',
      pageCount: 1,
      list: [],
      status: 1
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getList()
  },
  methods: {
    getList() {
      this.$fetch.post('Package/getPackageList', {
        page: this.page,
        status: this.status,
        search: this.searchValue
      }, true).then(res => {
        this.load.list = true
        this.list = res.result
        this.pageCount = res.page
      })
    },
    pageChange(e) {
      this.page = e
      this.getList()
    },
    searchOrder(e) {
      if (!e) {
        this.$message({
          type: 'info',
          message: '当前没有搜索任何信息'
        });
        return false
      }
      this.searchValue = e
      this.page = 1
      this.getList()

    },
    clearSearch() {
      console.log('清空搜索')
      this.searchValue = ''
      this.page = 1
      this.getList()
    },
    charge(id) {
      this.$prompt('请输入充值金额', '充值', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'number'
      }).then(({value}) => {
        this.$fetch.post('User/charge', {
          id: id,
          value: value
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '充值成功'
          });
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    adopt(id, owner) {
      this.$fetch.post('Group/adoptCreateApply', {
        id: id,
        owner: owner
      }, true).then(res => {
        this.page = 1
        this.getList()
      })
    },
    deletePackage(id) {
      this.$confirm('您将删除该包裹', '删除包裹', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('Package/deletePackage', {
          id: id,
        }, true).then(res => {
          this.page = 1
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消拒绝'
        });
      });
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 10px;
  background-color: #FFFFFF;
}
</style>
